import React from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from 'components/Typography';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.spacing(60.5)
  }
}));

interface EmptyPanelProps {
  message: string;
}

export default function EmptyPanel({ message }: EmptyPanelProps) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} data-testid="emptyPanel">
      <Typography>{message}</Typography>
    </div>
  );
}
